import Papa from "papaparse";

export function downloadCsv(
  filename: string,
  headers: string[],
  rows: Record<string, any>[]
) {
  const csv = Papa.unparse({
    fields: headers,
    data: rows.map((r) => headers.map((h) => r[h])),
  });

  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
